import { Link } from 'react-router-dom'
import {
  IonCard,
  IonCardContent,
  IonItem,
  IonLabel,
  IonText,
  IonCheckbox,
} from '@ionic/react'
import { format, formatDistance, isBefore, parseISO } from 'date-fns'

import Avatar from '../avatar'
import Currency from '../Currency'
import { AssociateSelect } from '../../clients/components/associate-select'
import { ClientTags } from '../client/client-tags'

import type { AdvancedClientDetail } from '../../clients/clients.schema'

function AdminClientCard({
  client,
  isSelected,
  onSelect,
  path,
}: {
  client: AdvancedClientDetail
  isSelected: boolean
  onSelect: (isSelected: boolean) => void
  path: string
}) {
  const lastPurchaseDate =
    client.lastSale !== undefined
      ? format(parseISO(client.lastSale.iso), 'MM/dd/yy')
      : null
  const nextContactDate =
    client.nextContact != null
      ? formatDistance(parseISO(client.nextContact.iso), new Date(), {
          addSuffix: true,
        })
      : null
  const lastContactDate =
    client.lastContact != null
      ? format(parseISO(client.lastContact.iso), 'MM/dd/yy')
      : null

  return (
    <IonCard key={client.objectId} color="secondary">
      <Link to={`/tabs/clients/client/${client.objectId}`}>
        <IonItem color="secondary" lines="none" className="pt-2">
          <div slot="start">
            <Avatar user={client} />
          </div>
          <IonLabel>
            <h2 className="text-ion-color-primary text-xl font-bold">
              {client.firstName} {client.lastName}
            </h2>
          </IonLabel>

          <IonCheckbox
            checked={isSelected}
            color="secondary"
            // TODO: onIonChange runs even if called remotely, POSSIBLE FIX in IONIC 7 TO USE onIonChange
            onClick={(e) => {
              onSelect((e.target as any).checked)
            }}
          />
        </IonItem>
        <IonCardContent className="py-2">
          <p>
            <span className="font-bold">TOTAL PURCHASED: </span>
            <Currency value={client.salesTotal} />
          </p>
          {lastPurchaseDate && (
            <p>
              <span className="font-bold">LAST PURCHASE: </span>
              <span>{lastPurchaseDate}</span>
            </p>
          )}
          {nextContactDate && (
            <IonText
              color={
                client.nextContact &&
                isBefore(parseISO(client.nextContact.iso), new Date())
                  ? 'danger'
                  : 'primary'
              }
            >
              <p
                className={
                  client.nextContact &&
                  isBefore(parseISO(client.nextContact.iso), new Date())
                    ? 'text-ion-color-danger'
                    : 'text-ion-color-primary'
                }
              >
                <span className="font-bold">NEXT CONTACT: </span>
                <span>{nextContactDate}</span>
              </p>
            </IonText>
          )}
          {lastContactDate && (
            <IonText>
              <p>
                <span className="font-bold">LAST CONTACTED: </span>
                <span>{lastContactDate}</span>
              </p>
            </IonText>
          )}
          <AssociateSelect client={client} />
        </IonCardContent>
      </Link>
      <ClientTags clientId={client.objectId} />
    </IonCard>
  )
}

export default AdminClientCard
